import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import type { HeaderFooterSharedProps } from 'src/types';

const getAuthStatus = ({ error, loading }: HeaderFooterSharedProps) => {
  if (error) {
    return AUTHENTICATION_TYPES.UNAUTHENTICATED;
  }
  return loading
    ? AUTHENTICATION_TYPES.AUTH_PENDING
    : AUTHENTICATION_TYPES.AUTHENTICATED;
};

export const useHeaderFooter = ({
  error,
  loading,
}: HeaderFooterSharedProps) => ({
  authenticationStatus: getAuthStatus({ error, loading }),
});
